import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { DocumentStore } from '../stores/documentStore';

export const useDocumentStore = () => useContext<{
  documentStore: DocumentStore
}>(StoreContext);
